import React, {useEffect} from "react";
import {CentredLoader} from "../../elements/Loader";
import {IdeaDetails} from "./IdeaDetails";
import {useSubscription} from "../../subscription/useSubscription";
import ideaActionsFactory from "../ideaActions";
import {useDispatch, useSelector} from "react-redux";
import styled from "styled-components";
import NoDataError from "./NoDataError";
import {Clock} from "js-joda";

const Container = styled.div`
    display: flex;
    flex-grow: 1;
`;

const IdeaDetailsController = ({closeModal, checkIdeaClosed}) => {
    const {ideaDetails, userIdentity, clock} = useSelector(({ideaDetails, userIdentity, clock}) => ({ideaDetails, userIdentity, clock: clock || Clock.systemDefaultZone()}));
    const dispatch = useDispatch();
    const ideaActions = ideaActionsFactory(dispatch);
    useSubscription("IDEA_DETAILS", ideaDetails.ideaId ? `/ui/api/ideas/${ideaDetails.ideaId}` : null, 60);
    useEffect(() => {
        document.onkeydown = (e) => {
            e = e || window.event;
            if (e.keyCode === 27) {
                closeModal();
            }
        };
        return () => {
            document.onkeydown = () => {};
        };
    }, []);

    let content;
    if (ideaDetails.loading) {
        content = <CentredLoader/>;
    } else if (!ideaDetails.data) {
        content = <NoDataError/>;
    } else {
        content = <IdeaDetails ideaDetails={ideaDetails}
                               ideaActions={ideaActions}
                               userIdentity={userIdentity}
                               checkIdeaClosed={checkIdeaClosed}
                               closeModal={closeModal}
                               clock={clock}/>;
    }

    return (
        <Container className="t-idea-details-container">
            {content}
        </Container>
    )
};

export default IdeaDetailsController;
